import React, { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const TransactionPopup = ({ open, onClose, row }) => {
  // const addNewURL = process.env.REACT_APP_TRANSACTION_POPUP;
  const addNewURL = process.env.REACT_APP_TRANSACTION_POPUP;
 
//   useEffect(() => {
        

//         const handleMessage = (event) => {
//             if (event.data && event.data.closePopup) {
//                 savePurpose();
//                 onClose();
//             }
//         };
//         window.addEventListener("message", handleMessage);
//         return () => {
//             window.removeEventListener("message", handleMessage);
//         };
//     }, []);

  const sale_id = row.sale_id;

  const newUrl = `${addNewURL}UserControls/TransactionPopup.aspx?popup=150&ID=${sale_id}&Order=undefined&TID=undefined&popupID=DailySalePopup&PopReport=1`;

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.closePopup) {
        onClose();
      }
    };

    window.addEventListener("message", handleMessage);
    
  }, [onClose]);

  return (
    <Dialog open={open} fullScreen>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          zIndex: 10,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        {sale_id && (
          <iframe
            src={newUrl}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="Transaction Popup"
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TransactionPopup;
